import { Link } from "react-router-dom";
import { ShieldMark } from "./ShieldMark";
import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const FooterInstitutional = () => {
  const { t } = useLang();
  const legalLinks = [
    { label: t.footer.links.aviso, to: "/aviso-legal" },
    { label: t.footer.links.privacidad, to: "/privacidad" },
    { label: t.footer.links.cookies, to: "/cookies" },
    { label: t.footer.links.terminos, to: "/terminos-de-uso" },
  ];
  return (
    <footer data-testid="footer-institutional" className="relative z-10 border-t border-onix-line bg-onix-black">
      <div className="onix-shell py-20 md:py-28 flex flex-col items-center text-center">
        <Reveal>
          <ShieldMark
            variant="white"
            className="w-[260px] md:w-[340px] mx-auto"
            alt="Escudo ONIX — Intelligence and Cybersecurity Systems"
          />
        </Reveal>
        <p data-testid="footer-motto" className="font-sans font-bold text-xs md:text-sm tracking-[0.3em] uppercase text-onix-white mt-10">
          INTELLIGENCE DRIVEN · MISSION FOCUSED
        </p>
        <p data-testid="footer-ownership" className="text-sm text-onix-silver mt-6">
          © ONIX {new Date().getFullYear()}
        </p>
      </div>
      <div className="border-t border-onix-line">
        <div className="onix-shell py-6 flex flex-col lg:flex-row items-center justify-between gap-4">
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2" aria-label={t.footer.legalNav}>
            {legalLinks.map((l) => (
              <Link
                key={l.to}
                data-testid={`footer-link-${l.to.replace("/", "")}`}
                to={l.to}
                className="text-[11px] font-bold uppercase tracking-[0.14em] text-onix-gray hover:text-onix-white transition-colors"
              >
                {l.label}
              </Link>
            ))}
            <Link
              data-testid="footer-link-contacto"
              to="/contacto"
              className="text-[11px] font-bold uppercase tracking-[0.14em] text-onix-gray hover:text-onix-white transition-colors"
            >
              {t.footer.links.contacto}
            </Link>
            <button
              data-testid="footer-cookie-settings"
              className="text-[11px] font-bold uppercase tracking-[0.14em] text-onix-gray hover:text-onix-white transition-colors"
              onClick={() => window.dispatchEvent(new CustomEvent("onix-open-cookies"))}
            >
              {t.footer.links.configurarCookies}
            </button>
          </nav>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <p data-testid="footer-copyright" className="tech-label">
              {t.footer.rights}
            </p>
            <p className="tech-label">onix-cybersecurity.tech</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
